import { render, staticRenderFns } from "./xixun.vue?vue&type=template&id=5a1c35e0"
import script from "./xixun.vue?vue&type=script&lang=js"
export * from "./xixun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports